window.initFormValidator = (form, options = {}) => {
    const baseOptions = {
        loader: true,
        successCallback: null,
        errorCallback: null,
        bodyLoader: true,
        disableButtons: true,
        afterSuccess: null,
        afterError: null,
        redirectUrl: null,
        dataTables: [],
    }
    for (const option in options) {
        baseOptions[option] = options[option];
    }
    const rules = {};
    const action = form.attr('action');
    $.each(form.find(':input'), function (index, element) {
        const el = $(element);
        if (el.data('rules')) {
            rules[el.attr('name')] = el.data('rules');
        }
    });
    const formValidation = form.validate({
        rules: rules,
        errorElement: 'span',
        errorPlacement: function (error, element) {
            error.addClass('invalid-feedback');
            element.closest('.form-group').append(error);
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid');
        },
        submitHandler: function (form, e) {
            e.preventDefault();
            const data = new FormData(form);
            const _form = $(form);
            $.each(_form.find(':input'), function (index, el) {
                const element = $(el);
                if (Array.isArray(element.val())) {
                    element.val().forEach((value, index) => {
                        data.append(`${element.attr('name')}[${index}]`, value)
                    });
                }
            });
            const button = _form.find('[type="submit"]');
            if (baseOptions.disableButtons) {
                button.prop('disabled', true);
            }
            if (baseOptions.bodyLoader) {
                setBodyLoader(true);
            }
            $.ajax({
                type: 'POST',
                url: action,
                data: data,
                processData: false,
                contentType: false
            }).then(function (response) {
                if (baseOptions.bodyLoader) {
                    setBodyLoader(false);
                }
                if (baseOptions.disableButtons) {
                    button.prop('disabled', false);
                }
                if (typeof baseOptions.successCallback === 'function') {
                    baseOptions.successCallback(response);
                } else {
                    if (typeof baseOptions.redirectUrl === 'function') {
                        window.location.href = baseOptions.redirectUrl(response);
                        return;
                    } else if (typeof baseOptions.redirectUrl === 'string' && baseOptions.redirectUrl) {
                        window.location.href = baseOptions.redirectUrl;
                        return;
                    }
                    if (Array.isArray(baseOptions.dataTables)) {
                        baseOptions.dataTables.forEach((datatable) => { datatable.draw('page'); });
                    } else if (baseOptions.dataTables) {
                        baseOptions.dataTables.draw('page');
                    }
                    if (typeof baseOptions.afterSuccess === 'function') {
                        baseOptions.afterSuccess(response);
                    }
                }
            }).catch(function (error) {
                if (baseOptions.bodyLoader) {
                    setBodyLoader(false);
                }
                if (baseOptions.disableButtons) {
                    button.prop('disabled', false);
                }
                if (typeof baseOptions.errorCallback === 'function') {
                    baseOptions.errorCallback(error);
                } else {
                    if (error.status === 422) {
                        const errors = error.responseJSON.errors;
                        window.handleValidationErrors(formValidation, errors);
                    } else {
                        Swal.fire(error.statusText, '', 'error')
                    }
                    if (typeof baseOptions.afterError === 'function') {
                        baseOptions.afterError(error);
                    }
                }
            });
        }
    });
    return formValidation;
}

window.handleValidationErrors = (formValidator, errors) => {
    for (const error in errors) {
        if (error.includes('.')) {
            let errorKey = error;
            let firstDot = true;
            while (errorKey.includes('.')) {
                if (firstDot) {
                    errorKey = errorKey.replace('.', '[');
                    firstDot = false;
                } else {
                    errorKey = errorKey.replace('.', '][');
                }
            }
            errorKey += ']';
            errors[errorKey] = errors[error];
            delete errors[error];
        }
    }
    window.openErroredCollapsiblePanels(errors);
    formValidator.showErrors(errors);
    Swal.fire($('meta[name="lang_error_validation_message"]').attr('content'), '', 'error')
}

window.openErroredCollapsiblePanels = (errors) => {
    for (const fieldName in errors) {
        const collapsiblePanel = $(`[name="${fieldName}"]`).closest('.collapsible-panel');
        if (collapsiblePanel.length) {
            collapsiblePanel.addClass('opened')
        }
    }
}
